__turbopack_context__.v({
  "label": "header-navigation-module-scss-module__Los5Ra__label",
  "root": "header-navigation-module-scss-module__Los5Ra__root",
});
